import { styled } from "@vitality-ds/system";
import BaseToasterStyles from "./styles/BaseToaster.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseToaster = styled("div", BaseToasterStyles);